import axios from "axios";
import {
  get_All_customers,
  get_Single_Customers,
  get_customer_invoice,
} from "../../Redux/RegisterdList/registerdUserSlice";
import { store } from "../../Redux/Store";
import { HEADERS } from "../urlAndPath";


// getAllCustomers Api

export const getAllCustomers = (setisLoading, page = 0) => {
  console.log("registerdUsers api - page:", page);
  axios
    .post("customer/viewregisteredusers", { index: page }, HEADERS)
    .then((res) => {
      if (res.status === 200) {
        console.log("📋 Customers loaded:", res.data);
        store.dispatch(
          get_All_customers({ registerdUserData: res.data })
        );
        setisLoading(false);
      }
    })
    .catch((err) => {
      console.log("❌ Error loading customers:", err);
      setisLoading(false);
    });
};

export const renewBranchManualAPICall = (
  body,
  setLoadingForm,
  setState,
  state,
  onSuccess
) => {
  setLoadingForm(true);
  axios
    .post("admin/renewbranchManual", body, HEADERS)
    .then((res) => {
      if (res.status === 200) {
        setLoadingForm(false);
        setState({
          ...state,
          success: true,
          message: res?.data || "Outlet renewed successfully",
        });
        if (typeof onSuccess === "function") {
          onSuccess();
        }
      }
    })
    .catch((err) => {
      setLoadingForm(false);
      const message =
        err?.response?.data ||
        (err?.response?.status === 500
          ? "Internal Server error !"
          : "Unable to renew outlet");
      setState({ ...state, message, error: true });
    });
};

export const renewPackageManualAPICall = (
  body,
  setLoadingForm,
  setState,
  state,
  onSuccess
) => {
  setLoadingForm(true);
  axios
    .post("admin/renewpackageManual", body, HEADERS)
    .then((res) => {
      if (res.status === 200) {
        setLoadingForm(false);
        setState({
          ...state,
          success: true,
          message: res?.data || "Package renewed successfully",
        });
        if (typeof onSuccess === "function") {
          onSuccess();
        }
      }
    })
    .catch((err) => {
      setLoadingForm(false);
      const message =
        err?.response?.data ||
        (err?.response?.status === 500
          ? "Internal Server error !"
          : "Unable to renew package");
      setState({ ...state, message, error: true });
    });
};


//getSingleCustomer


export const getSingleCustomer=(body,setLoadingForm)=>{
    setLoadingForm(true)
    axios.post("customer/viewcustomersingle",body,HEADERS)
    .then((res)=>{

        
        if(res.status === 200){
            // console.log(res)
            store.dispatch(get_Single_Customers({singleUserData:res.data}))
            setLoadingForm(false)
        }
        
    }).catch((err)=>{
        console.log("error occured...")
        setLoadingForm(false)
    })

}

// suspend user api call
export const suspendUserApiCall=(body)=>{
    axios.post("admin/suspenduseraccount",body,HEADERS)
    .then((res)=>{
         if(res.status===200){
           console.log('aa');
         }
    })
    .catch((err)=>{
        console.log(err.response);
    })
}

export const balancePaymentAPICall=(body,setLoadingForm,setState,state,setBalancePayment,updateListner)=>{
    const singleViewId=localStorage.getItem("singleViewId")
    axios.post("admin/clearbalance",body,HEADERS)
    .then((res)=>{
        if(res.status===200){
            console.log('seccess');
            
            setState({...state,message:"Payment Success",success:true})
            getSingleCustomer({_id:singleViewId},setLoadingForm)
            setBalancePayment(false)
            updateListner()
        }
    })
    .catch((err)=>{
        console.log(err.response);
        if (err.response.status === 500) {
            setState({ ...state, message:"Internal Server error !", error: true })
          } else {
            setState({ ...state, message:err?.response?.data,error: true })
          }
    })
}

// reset passowrd
export const resetPasswordAPICall=(body,setState,state,setPasswordReset)=>{
    axios.post("admin/updateUserPassword",body,HEADERS)
    .then((res)=>{
        if(res.status===200){
           console.log('success');
           setState({...state,message:"Success",success:true})
           setPasswordReset(false)
        }
    })
    .catch((err)=>{
        console.log(err.response);
        if (err.response.status === 500) {
            setState({ ...state, message:"Internal Server error !", error: true })
          } else {
            setState({ ...state, message:err?.response?.data,error: true })
          }
    })
}

export const viewInvoiceOfCustomer=(body,setOpenInvoice,setState,state)=>{
    axios.post("admin/invoiceview",body,HEADERS)
    .then((res)=>{
        if(res.status===200){
            // console.log('aaa');
            store.dispatch(get_customer_invoice({customerInvoiceData:res.data}))
            setOpenInvoice(true)
        }
    })
    .catch((err)=>{
        if (err.response.status === 500) {
            setState({ ...state, message:"Internal Server error !", error: true })
          } else {
            setState({ ...state, message:err?.response?.data,error: true })
          }
    })
}

// Manual seat-license adjust for LEEYET plans.
// body: { planId, delta, ratePerSeat?, note? }
export const adjustLicenseAPICall = (body, singleViewId, setLoadingForm, setState, state, onDone) => {
  if (setLoadingForm) setLoadingForm(true);
  return axios
    .post("customer/adjustLicense", body, HEADERS)
    .then((res) => {
      if (res.status === 200) {
        if (setLoadingForm) setLoadingForm(false);
        setState({
          ...state,
          success: true,
          message:
            (Number(body.delta) > 0 ? "Added " : "Removed ") +
            Math.abs(Number(body.delta)) +
            " license(s)",
        });
        // Refresh the single-view so the panel reflects new qty/rate/history.
        if (singleViewId) getSingleCustomer({ _id: singleViewId }, setLoadingForm || (() => {}));
        if (typeof onDone === "function") onDone(res.data);
        return res.data;
      }
    })
    .catch((err) => {
      if (setLoadingForm) setLoadingForm(false);
      const msg =
        err?.response?.status === 500
          ? "Internal Server error !"
          : err?.response?.data || "Failed to adjust license";
      setState({ ...state, error: true, message: msg });
    });
}

// Apply a payment against an outstanding balance on a license-history entry.
// body: { planId, historyAt | historyIndex, amount, note? }
export const payLicenseBalanceAPICall = (
  body,
  singleViewId,
  setLoadingForm,
  setState,
  state,
  onDone
) => {
  if (setLoadingForm) setLoadingForm(true);
  return axios
    .post("customer/payLicenseBalance", body, HEADERS)
    .then((res) => {
      if (res.status === 200) {
        if (setLoadingForm) setLoadingForm(false);
        setState({
          ...state,
          success: true,
          message: "Payment recorded (₹" + Number(body.amount || 0) + ")",
        });
        if (singleViewId) getSingleCustomer({ _id: singleViewId }, setLoadingForm || (() => {}));
        if (typeof onDone === "function") onDone(res.data);
        return res.data;
      }
    })
    .catch((err) => {
      if (setLoadingForm) setLoadingForm(false);
      const msg =
        err?.response?.status === 500
          ? "Internal Server error !"
          : err?.response?.data || "Failed to record payment";
      setState({ ...state, error: true, message: msg });
    });
}

// Reverse + remove a license-history entry (undo an added/removed seat).
// body: { planId, historyAt | historyIndex }
export const deleteLicenseHistoryAPICall = (
  body,
  singleViewId,
  setLoadingForm,
  setState,
  state,
  onDone
) => {
  if (setLoadingForm) setLoadingForm(true);
  return axios
    .post("customer/deleteLicenseHistory", body, HEADERS)
    .then((res) => {
      if (res.status === 200) {
        if (setLoadingForm) setLoadingForm(false);
        setState({
          ...state,
          success: true,
          message: "Adjustment deleted",
        });
        if (singleViewId) getSingleCustomer({ _id: singleViewId }, setLoadingForm || (() => {}));
        if (typeof onDone === "function") onDone(res.data);
        return res.data;
      }
    })
    .catch((err) => {
      if (setLoadingForm) setLoadingForm(false);
      const msg =
        err?.response?.status === 500
          ? "Internal Server error !"
          : err?.response?.data || "Failed to delete adjustment";
      setState({ ...state, error: true, message: msg });
    });
}